import './member-password-reset-form.scss'
import {
    MemberPasswordResetCreateFormComponent,
    MemberPasswordResetCreateFormFieldComponent,
    MemberPasswordResetCreateFormFieldName,
    type MemberPasswordResetCreateFormProps,
} from '@vista-digital/occ-ui'
import type { FC } from 'react'
import ButtonLink from '@/common/components/buttonLink/ButtonLink'
import type { PasswordResetPropsApi } from '@/common/components/signInForm/memberPasswordResetForm/passwordReset.models'
import type { MemberSignInFormPropsApi } from '@/common/components/signInForm/memberSignInForm/models'
import { useHasCaptcha } from '@/common/hooks/useHasCaptcha'
import { getIdentifierFieldProps, passwordResetProps } from './props'

export interface MemberPasswordResetFormProps {
    displayText: PasswordResetPropsApi & { backToSignInText?: string }
    memberSignInDisplayText: MemberSignInFormPropsApi
    events: MemberPasswordResetCreateFormProps['events']
    onNavigateToSignIn?: () => void
}

export const MemberPasswordResetForm: FC<MemberPasswordResetFormProps> = props => {
    const { onNavigateToSignIn, displayText } = props
    const captchaEnabled = useHasCaptcha()

    const formProps = passwordResetProps({ ...props, captchaEnabled })

    return (
        <>
            <MemberPasswordResetCreateFormComponent {...formProps}>
                <MemberPasswordResetCreateFormFieldComponent
                    {...getIdentifierFieldProps(props.memberSignInDisplayText)}
                />
                {captchaEnabled && (
                    <MemberPasswordResetCreateFormFieldComponent
                        name={MemberPasswordResetCreateFormFieldName.Captcha}
                    />
                )}
            </MemberPasswordResetCreateFormComponent>
            <ButtonLink
                label={displayText.backToSignInText || 'Go back to sign in'}
                onClick={onNavigateToSignIn}
                className="go-back"
            />
        </>
    )
}
